const Coagadex = () => {
  return (
    <>
      <div>
        <div className="mt-10 text-2xl font-bold">COPAY ASSISTANCE</div>

        <p className="my-2">
          If your patient’s primary payer drug claim is billed under medical benefits, you can
          request COAGADEX (Coagulation Factor X, Human) copay assistance using this portal.
          Eligible patients can receive up to $12,000 per year to cover their out of pocket
          expenses. Note: Nursing and supply costs that may be associated with the administration of
          the medication are not eligible for assistance through this program.
        </p>

        <div className="mt-10 font-bold">ELIGIBILITY CRITERIA FOR COPAY ASSISTANCE</div>

        <ul className="my-2 list-disc ml-10">
          <li>Valid for out-patient prescriptions only</li>
          <li>
            The Coagadex Copay Support Program is for patients who have a valid prescription for
            Coagadex regardless of financial need
          </li>
          <li>
            Patient must have coverage for the product under a private US insurance plan. Not valid
            for prescriptions reimbursed by Medicaid, Medicare, VA, TRICARE, or any other federal or
            state healthcare programs
          </li>
        </ul>

        <div className="font-bold">RESTRICTIONS</div>

        <ul className="my-2 list-disc ml-10">
          <li>
            Patients whose insurance policy prohibits copay assistance are not eligible*
            <p className="mt-4 italic">
              * Prior to enrolling in this Kedrion Biopharma Inc. program, participants are
              responsible for checking with their insurance carrier to confirm that their
              participation is not inconsistent with their insurance carrier’s requirements.
            </p>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Coagadex;
